// in src/Dashboard.js
import * as React from "react";
import { Card, CardContent, CardHeader } from '@mui/material';
import { url_download_panduan } from "../constant/constant";

const Faq = () => (
    <Card style={{marginTop: "20px"}}>
        <CardHeader title="FAQ" />
        <CardContent>
            <strong>Q: Apa itu STARLA?</strong>
            <p>A: STARLA, merupakan sistem untuk mempermudah antrian pengunjung layanan perpustakaan (PST) di BPS Provinsi Sulawesi Tenggara.</p>
            <br/>
            {/* <strong>Q: Apa tujuan STARLA?</strong>
            <p>A: Aplikasi ini merupakan alat bantu untuk melakukan alokasi pekerjaan untuk mitra dalam waktu 1 bulan agar beban kerja merata dan
                honor pekerjaan tidak melewati rate honor maksimal sesuai dengan ketentuan dari SBML.</p>
            <br/> */}
            <strong>Q: Apa saja fitur-fitur STARLA?</strong>
            <p>A: (1) Fitur Daftar Antrian (2) Fitur Survey Kepuasan. 
            (3) Fitur Tampilan Dashboard dan Panggilan Pengunjung. (4) Backend dan Report Antrian.</p>
            <br/>
            <strong>Q: Browser apa yang disupport oleh STARLA?</strong>
            <p>A: Browser terbaru (evergreen) firefox dan chrome disuport oleh STARLA, sedangkan internet explorer dan browser versi lawas tidak disupport oleh STARLA.</p>
            <br/>
            <strong>Q: Apakah maksud kolom P1 - P10 pada menu report penilaian?</strong>
            <p>A: P1-P10 merupakan butir pertanyaan pada Survey Kepuasan pada <a href="https://sultradata.com/project/display-antrian/survey">Link Survey</a> berikut</p>

        </CardContent>
    </Card>
);

export default Faq;